// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-app-section {
  display: flex;
  flex-direction: column;
}
.my-app-section h1 {
  padding-left: 20px;
}
.my-app-section .p-18 {
  padding: 0 18px 18px 18px;
}

.my_apps_container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}
.my_apps_container .my_apps-blocks {
  display: flex;
  flex-direction: column;
}
.my_apps_container .misc-actions-container {
  display: flex;
  justify-content: right;
  width: 100%;
}
.my_apps_container .misc-actions-container .myapps-cta-btns {
  display: flex;
  margin-left: 10%;
  flex-direction: row;
}
.my_apps_container .app-content-header {
  display: flex;
  flex-direction: row;
  margin-top: 1%;
}
.my_apps_container .banner-container {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  height: 340px;
}
.my_apps_container .banner-container img {
  width: 100%;
}
.my_apps_container .banner-container .banner-title {
  font-size: 24px;
  color: #262626;
  margin: 0;
  padding: 0;
}
.my_apps_container .banner-container .banner-sub-title {
  font-family: "ABBVoice-medium";
  font-size: 16px;
}
.my_apps_container .banner-container .banner-title span {
  font-family: "ABBVoice-light";
  font-size: 24px;
  color: #262626;
  margin: 0;
  padding: 0;
}
.my_apps_container .banner-container .carousel-cover {
  display: flex;
}
.my_apps_container .banner-container .carousel-cover .banner-img-container {
  display: flex;
  height: 300px;
}
.my_apps_container .banner-container .carousel-cover .banner-img-container .banner-img {
  display: flex;
  height: 300px;
  background: #f1f2f2;
  justify-content: center;
  align-items: center;
}
.my_apps_container .banner-container .carousel-cover .banner-content {
  display: flex;
  height: 300px;
  width: 30%;
  justify-content: center;
  align-items: center;
}
.my_apps_container .thumbs-wrapper,
.my_apps_container .carousel-status {
  display: none;
}

.my_app_list {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 20px 0 20px;
}
.my_app_list h4.app-list-title {
  font-family: "ABBVoice-light";
  font-size: 14px;
  color: #ff000f;
  margin: 0 0 0 15px;
  padding: 0;
}

.blocks-container {
  overflow-y: hidden;
}
.blocks-container .app-block {
  min-width: 100% !important;
}

.apps {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.blocks-container {
  justify-content: left;
  margin-bottom: 25px;
  gap: 38px;
}
.blocks-container a {
  text-decoration: none !important;
  color: black !important;
  min-width: 100% !important;
}

.blocks {
  border-radius: 5px;
  background: white;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 90% !important;
  height: 180px !important;
  margin: 13px !important;
  padding: 15px 15px 0 15px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 1px solid transparent;
  cursor: pointer !important;
  overflow: hidden;
}

.app-info {
  display: flex;
  align-items: center;
}

.app-name {
  font-size: 14px;
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.app-name h4 {
  font-family: "ABBVoice-bold";
  font-size: 14px;
  padding: 0;
  margin: 0;
}

.blocks-container .blocks .box-content {
  align-items: center !important;
  padding: 0 20px !important;
  overflow: auto;
}

.app-link {
  display: flex;
  margin-left: auto;
  color: #3366ff;
  font-family: "ABBVoice-medium";
  font-size: 12px;
}
.app-link a {
  color: #3366ff;
  text-transform: uppercase;
  text-decoration: none;
}

.blocks:hover {
  background: var(--blocks-hover-background-color) !important;
  border: 1px solid var(--blocks-hover-border-color) !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.btn-add-application {
  font-family: "ABBVoice-medium";
  display: flex;
  width: 150px;
  padding: 5px 0;
  background: #36f;
  color: white;
  border-radius: 15px;
  font-size: 13px;
  border: 1px solid #ccc;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  line-height: 20px;
}
.btn-add-application .icon-plus {
  display: flex;
  width: 12px;
  height: 12px;
  padding: 0 10px;
  color: white;
}
.btn-add-application a {
  color: white;
  text-decoration: none;
}
.btn-add-application .link {
  display: flex;
  padding-left: 10px;
  margin-top: 1px;
}

.myapp-headings {
  margin-left: 2%;
}

.intro-content-myapps {
  margin-top: 15px;
  margin-left: 2%;
}

.blocks-container .blocks .image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
  line-height: 0;
}
.blocks-container .blocks .image-container img {
  height: 18px;
  width: 18px;
}

.blocks-container .blocks .box-content {
  align-items: center;
  padding: 0 20px;
}
.blocks-container .blocks .box-content p {
  margin: 0 0 10px 0;
  font-size: 12px !important;
  text-align: left !important;
  margin-top: 0px !important;
  margin-left: 32px !important;
}

.filter-content {
  width: 300px;
  padding: 2%;
}
.filter-content-title {
  font-size: 16px;
  font-weight: 700;
}
.filter-content-button-container {
  display: flex;
  gap: 15px;
}
.filter-content-button-container .filter-button {
  background-color: rgba(0, 0, 0, 0.0784313725);
  border: 1px solid rgba(0, 0, 0, 0.0784313725);
  padding: 3% 5%;
  font-size: 14px;
  font-weight: 700;
}
.filter-content-button-container .filter-button-left {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: #3366ff;
  color: white;
}
.filter-content-button-container .filter-button-right {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
.filter-content-category {
  margin-top: 2%;
}
.filter-content-category-title {
  font-size: 14px;
  font-weight: 500;
}
.filter-content-category-checkbox {
  margin: 1%;
  display: flex;
  flex-direction: column;
}
.filter-content-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 5%;
}
.filter-content-footer-link .ant-btn-link {
  padding: 0;
}

.icon-sort {
  font-size: 14px;
}

intro-content {
  margin-top: 15px;
}

.my-app-blocks-container {
  flex-direction: row;
  margin-bottom: 25px;
  margin-left: 14px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/myapps.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;;AACA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAEF;AAAE;EACE,aAAA;EACA,sBAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEJ;AADI;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AAGN;AACE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAAJ;AACI;EACE,WAAA;AACN;AAEI;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAAN;AAGI;EACE,8BAAA;EACA,eAAA;AADN;AAII;EACE,6BAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAKM;EACE,aAAA;EACA,aAAA;AAHR;AAKQ;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAHV;AAOM;EACE,aAAA;EACA,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AALR;AAUE;;EAEE,aAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AATF;AAWE;EACE,6BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AATJ;;AAYA;EACE,kBAAA;AATF;AAWE;EACE,0BAAA;AATJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAWA;EACE,qBAAA;EACA,mBAAA;EACA,SAAA;AARF;AAUE;EACE,gCAAA;EACA,uBAAA;EACA,0BAAA;AARJ;;AAWA;EACE,kBAAA;EACA,iBAAA;EACA,+CAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,gBAAA;AARF;;AAUA;EACE,aAAA;EACA,mBAAA;AAPF;;AAUA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAPF;AASE;EACE,4BAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAPJ;;AAUA;EACE,8BAAA;EACA,0BAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;AAPF;AAQE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AANJ;;AAUA;EAGE,2DAAA;EACA,6DAAA;EACA,+CAAA;AATF;;AAYA;EACE,8BAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AATF;AAWE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AATJ;AAYE;EACE,YAAA;EACA,qBAAA;AAVJ;AAaE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;AAXJ;;AAcA;EACE,eAAA;AAXF;;AAaA;EACE,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAVF;AAYE;EACE,YAAA;EACA,WAAA;AAVJ;;AAaA;EACE,mBAAA;EACA,eAAA;AAVF;AAWE;EACE,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AATJ;;AAaA;EACE,YAAA;EACA,WAAA;AAVF;AAWE;EACE,eAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;EACA,SAAA;AAVJ;AAWI;EACE,6CAAA;EACA,6CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATN;AAUM;EACE,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,YAAA;AARR;AAUM;EACE,6BAAA;EACA,gCAAA;AARR;AAYE;EACE,cAAA;AAVJ;AAWI;EACE,eAAA;EACA,gBAAA;AATN;AAWI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AATN;AAYE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AAVJ;AAYM;EACE,UAAA;AAVR;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,gBAAA;AAbF;;AAeA;EACE,mBAAA;EAEA,mBAAA;EACA,iBAAA;AAbF","sourcesContent":[".my-app-section {\n  display: flex;\n  flex-direction: column;\n  h1 {\n    padding-left: 20px;\n  }\n  .p-18 {\n    padding: 0 18px 18px 18px;\n  }\n}\n.my_apps_container {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n\n  .my_apps-blocks {\n    display: flex;\n    flex-direction: column;\n  }\n  .misc-actions-container {\n    display: flex;\n    justify-content: right;\n    width: 100%;\n    .myapps-cta-btns {\n      display: flex;\n      margin-left: 10%;\n      flex-direction: row;\n    }\n  }\n\n  .app-content-header {\n    display: flex;\n    flex-direction: row;\n    margin-top: 1%;\n  }\n\n  .banner-container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 25px;\n    height: 340px;\n    img {\n      width: 100%;\n    }\n\n    .banner-title {\n      font-size: 24px;\n      color: #262626;\n      margin: 0;\n      padding: 0;\n    }\n\n    .banner-sub-title {\n      font-family: \"ABBVoice-medium\";\n      font-size: 16px;\n    }\n\n    .banner-title span {\n      font-family: \"ABBVoice-light\";\n      font-size: 24px;\n      color: #262626;\n      margin: 0;\n      padding: 0;\n    }\n\n    .carousel-cover {\n      display: flex;\n\n      .banner-img-container {\n        display: flex;\n        height: 300px;\n\n        .banner-img {\n          display: flex;\n          height: 300px;\n          background: #f1f2f2;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .banner-content {\n        display: flex;\n        height: 300px;\n        width: 30%;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  .thumbs-wrapper,\n  .carousel-status {\n    display: none;\n  }\n}\n\n.my_app_list {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  padding: 0 20px 0 20px;\n\n  h4.app-list-title {\n    font-family: \"ABBVoice-light\";\n    font-size: 14px;\n    color: #ff000f;\n    margin: 0 0 0 15px;\n    padding: 0;\n  }\n}\n.blocks-container {\n  overflow-y: hidden;\n\n  .app-block {\n    min-width: 100% !important;\n  }\n}\n.apps {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.blocks-container {\n  justify-content: left;\n  margin-bottom: 25px;\n  gap: 38px;\n\n  a {\n    text-decoration: none !important;\n    color: black !important;\n    min-width: 100% !important;\n  }\n}\n.blocks {\n  border-radius: 5px;\n  background: white;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  width: 90% !important;\n  height: 180px !important;\n  margin: 13px !important;\n  padding: 15px 15px 0 15px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  border: 1px solid transparent;\n  cursor: pointer !important;\n  overflow: hidden;\n}\n.app-info {\n  display: flex;\n  align-items: center;\n}\n\n.app-name {\n  font-size: 14px;\n  white-space: nowrap;\n  width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  h4 {\n    font-family: \"ABBVoice-bold\";\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n  }\n}\n.blocks-container .blocks .box-content {\n  align-items: center !important;\n  padding: 0 20px !important;\n  overflow: auto;\n}\n\n.app-link {\n  display: flex;\n  margin-left: auto;\n  color: #3366ff;\n  font-family: \"ABBVoice-medium\";\n  font-size: 12px;\n  a {\n    color: #3366ff;\n    text-transform: uppercase;\n    text-decoration: none;\n  }\n}\n\n.blocks:hover {\n  // background: #3366ff29 !important;\n  // border: 1px solid #2934ff;\n  background: var(--blocks-hover-background-color) !important;\n  border: 1px solid var(--blocks-hover-border-color)!important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n.btn-add-application {\n  font-family: \"ABBVoice-medium\";\n  display: flex;\n  width: 150px;\n  padding: 5px 0;\n  background: #36f;\n  color: white;\n  border-radius: 15px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  flex-direction: row;\n  align-items: center;\n  line-height: 20px;\n\n  .icon-plus {\n    display: flex;\n    width: 12px;\n    height: 12px;\n    padding: 0 10px;\n    color: white;\n  }\n\n  a {\n    color: white;\n    text-decoration: none;\n  }\n\n  .link {\n    display: flex;\n    padding-left: 10px;\n    margin-top: 1px;\n  }\n}\n.myapp-headings {\n  margin-left: 2%;\n}\n.intro-content-myapps {\n  margin-top: 15px;\n  margin-left: 2%;\n}\n\n.blocks-container .blocks .image-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  width: 42px !important;\n  height: 42px !important;\n  border-radius: 50%;\n  line-height: 0;\n\n  img {\n    height: 18px;\n    width: 18px;\n  }\n}\n.blocks-container .blocks .box-content {\n  align-items: center;\n  padding: 0 20px;\n  p {\n    margin: 0 0 10px 0;\n    font-size: 12px !important;\n    text-align: left !important;\n    margin-top: 0px !important;\n    margin-left: 32px !important;\n  }\n}\n\n.filter-content {\n  width: 300px;\n  padding: 2%;\n  &-title {\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  &-button-container {\n    display: flex;\n    gap: 15px;\n    .filter-button {\n      background-color: #00000014;\n      border: 1px solid #00000014;\n      padding: 3% 5%;\n      font-size: 14px;\n      font-weight: 700;\n      &-left {\n        border-top-left-radius: 30px;\n        border-bottom-left-radius: 30px;\n        background-color: #3366ff;\n        color: white;\n      }\n      &-right {\n        border-top-right-radius: 30px;\n        border-bottom-right-radius: 30px;\n      }\n    }\n  }\n  &-category {\n    margin-top: 2%;\n    &-title {\n      font-size: 14px;\n      font-weight: 500;\n    }\n    &-checkbox {\n      margin: 1%;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n  &-footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 5%;\n    &-link {\n      .ant-btn-link {\n        padding: 0;\n      }\n    }\n  }\n}\n\n.icon-sort {\n  font-size: 14px;\n}\n\nintro-content {\n  margin-top: 15px;\n}\n.my-app-blocks-container {\n  flex-direction: row;\n\n  margin-bottom: 25px;\n  margin-left: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
